var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSponsor6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 303,
    height: 178,
    viewBox: "0 0 303 178",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.494141,
    y: 0.808594,
    width: 302,
    height: 177,
    rx: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.3324 72.5362L43.8184 77.3614L46.7909 68.3491L55.3324 72.5362Z",
    fill: "url(#paint0_linear_236_217)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7539 81.1384L43.7845 77.3501L39.2692 89.1537L34.7539 81.1384Z",
    fill: "url(#paint1_linear_236_217)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0813 101.227L35.3517 97.9968L35.2012 97.9569L35.2764 97.7974L39.2649 89.144L44.0813 101.227Z",
    fill: "url(#paint2_linear_236_217)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1773 110.368L44.0918 101.276V101.236L55.3424 105.862L47.1773 110.368Z",
    fill: "url(#paint3_linear_236_217)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1837 110.368L55.3489 118.822L44.625 116.549L47.1837 110.368Z",
    fill: "url(#paint4_linear_236_217)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2656 62.2411L55.3281 59.8086L46.7867 68.3423L44.3033 62.2411H44.2656Z",
    fill: "url(#paint5_linear_236_217)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4884 100.302L27.4941 89.5352L35.2078 97.9492L29.4884 100.302Z",
    fill: "url(#paint6_linear_236_217)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4941 89.5556V89.3163L29.4508 78.4697L34.7563 81.1415L27.4941 89.5556Z",
    fill: "url(#paint7_linear_236_217)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.8047 68.3423L55.3461 72.5294V59.8086L46.8047 68.3423Z",
    fill: "url(#paint8_linear_236_217)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.3429 118.86L47.1777 110.407L55.3429 105.9V118.86Z",
    fill: "url(#paint9_linear_236_217)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1667 110.372L35.5022 110.013L35.2012 97.9697L44.0813 101.24L47.1667 110.372Z",
    fill: "url(#paint10_linear_236_217)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6137 116.539L35.5078 109.999L47.1724 110.358L44.6137 116.539Z",
    fill: "url(#paint11_linear_236_217)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.7947 68.3491L35.4312 68.708L34.7539 81.1497L43.8221 77.3614L46.7947 68.3491Z",
    fill: "url(#paint12_linear_236_217)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.418 68.6935L44.2981 62.2334L46.7815 68.3346L35.418 68.6935Z",
    fill: "url(#paint13_linear_236_217)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2676 89.1737L43.7829 77.3701L55.3346 72.5449V105.882L44.0839 101.256L39.2676 89.1737Z",
    fill: "url(#paint14_linear_236_217)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5121 110.013L29.5293 100.322L35.2111 97.9697L35.5121 110.013Z",
    fill: "url(#paint15_linear_236_217)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4941 89.562L34.7563 81.1479L39.2716 89.1633L35.2078 97.9761L27.4941 89.562Z",
    fill: "url(#paint16_linear_236_217)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4609 78.4569L35.4437 68.687L34.7664 81.1287L29.4609 78.4569Z",
    fill: "url(#paint17_linear_236_217)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.3516 96.3961V97.9912L85.7821 84.1937C85.7068 83.7152 85.5939 83.1968 85.5187 82.7183L58.3516 96.3961Z",
    fill: "#C51315"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.3516 85.8412V93.8964L84.9542 80.5376C84.2769 78.1848 83.2986 75.9916 82.0945 73.918L58.3516 85.8412Z",
    fill: "#E30613"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.3516 82.5813V84.0568L81.2667 72.5721C81.041 72.2132 80.7776 71.8145 80.5142 71.4556L58.3516 82.5813Z",
    fill: "#DADADA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.3516 72.7085V79.2882L78.6328 69.1196C77.2406 67.5245 75.6602 66.0889 73.9294 64.8926L58.3516 72.7085Z",
    fill: "#008BD2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.3516 59.8086V68.4619L70.0914 62.5601C66.5544 60.8055 62.5659 59.8086 58.3516 59.8086Z",
    fill: "#008BD2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.3516 102.681L86.196 88.6846C86.196 88.884 86.196 89.0833 86.196 89.3226C86.196 105.592 73.7036 118.832 58.3516 118.832V102.681Z",
    fill: "#009640"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M102.205 94.0655V83.129L102.629 83.574H98.1504V82.085H107.938V83.574H103.46L103.867 83.129V94.0655H102.205Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M112.804 94.1682C111.843 94.1682 110.994 93.9685 110.259 93.5692C109.536 93.1698 108.97 92.6222 108.563 91.9261C108.167 91.2301 107.969 90.4314 107.969 89.53C107.969 88.6286 108.162 87.8299 108.546 87.1339C108.942 86.4379 109.479 85.8959 110.158 85.508C110.847 85.1086 111.622 84.909 112.482 84.909C113.352 84.909 114.121 85.1029 114.788 85.4909C115.456 85.8788 115.976 86.4265 116.349 87.1339C116.734 87.8299 116.926 88.6458 116.926 89.5814C116.926 89.6498 116.92 89.7297 116.909 89.821C116.909 89.9123 116.903 89.9978 116.892 90.0777H109.242V88.8968H116.044L115.382 89.3075C115.393 88.7256 115.275 88.2065 115.026 87.7501C114.777 87.2937 114.432 86.9399 113.991 86.6889C113.562 86.4265 113.058 86.2953 112.482 86.2953C111.916 86.2953 111.413 86.4265 110.972 86.6889C110.531 86.9399 110.186 87.2994 109.937 87.7672C109.688 88.2236 109.564 88.7484 109.564 89.3418V89.6156C109.564 90.2203 109.7 90.7623 109.971 91.2415C110.254 91.7094 110.644 92.0745 111.141 92.3369C111.639 92.5993 112.21 92.7306 112.855 92.7306C113.386 92.7306 113.867 92.6393 114.297 92.4567C114.738 92.2742 115.122 92.0003 115.45 91.6352L116.349 92.6963C115.942 93.1755 115.433 93.5407 114.822 93.7917C114.223 94.0427 113.55 94.1682 112.804 94.1682Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M117.779 94.0655L121.646 88.9995L121.629 89.8381L117.948 84.9945H119.763L122.579 88.7256H121.884L124.7 84.9945H126.481L122.749 89.8723L122.766 88.9995L126.667 94.0655H124.818L121.85 90.0948L122.511 90.1975L119.594 94.0655H117.779Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M128.381 94.0655V84.9945H130.009V88.8454H135.132V84.9945H136.76V94.0655H135.132V90.266H130.009V94.0655H128.381Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M143.777 94.1682C142.873 94.1682 142.07 93.9685 141.369 93.5692C140.668 93.1698 140.113 92.6222 139.706 91.9261C139.299 91.2187 139.096 90.42 139.096 89.53C139.096 88.6286 139.299 87.8299 139.706 87.1339C140.113 86.4379 140.668 85.8959 141.369 85.508C142.07 85.1086 142.873 84.909 143.777 84.909C144.671 84.909 145.468 85.1086 146.169 85.508C146.882 85.8959 147.436 86.4379 147.832 87.1339C148.239 87.8185 148.442 88.6172 148.442 89.53C148.442 90.4314 148.239 91.2301 147.832 91.9261C147.436 92.6222 146.882 93.1698 146.169 93.5692C145.468 93.9685 144.671 94.1682 143.777 94.1682ZM143.777 92.7306C144.354 92.7306 144.869 92.5993 145.321 92.3369C145.785 92.0745 146.147 91.7036 146.407 91.2244C146.667 90.7338 146.797 90.169 146.797 89.53C146.797 88.8797 146.667 88.3206 146.407 87.8528C146.147 87.3735 145.785 87.0027 145.321 86.7403C144.869 86.4778 144.354 86.3466 143.777 86.3466C143.201 86.3466 142.686 86.4778 142.234 86.7403C141.781 87.0027 141.42 87.3735 141.148 87.8528C140.877 88.3206 140.741 88.8797 140.741 89.53C140.741 90.169 140.877 90.7338 141.148 91.2244C141.42 91.7036 141.781 92.0745 142.234 92.3369C142.686 92.5993 143.201 92.7306 143.777 92.7306Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M150.794 94.0655V84.9945H159.123V94.0655H157.494V86.0214L157.884 86.4322H152.032L152.422 86.0214V94.0655H150.794Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M167.786 94.0655V92.1486L167.702 91.7892V88.5202C167.702 87.8242 167.498 87.288 167.091 86.9114C166.695 86.5235 166.096 86.3295 165.293 86.3295C164.761 86.3295 164.241 86.4208 163.732 86.6033C163.223 86.7745 162.794 87.0084 162.443 87.3051L161.765 86.0728C162.228 85.6962 162.782 85.411 163.427 85.217C164.083 85.0116 164.767 84.909 165.479 84.909C166.712 84.909 167.662 85.2113 168.329 85.8161C168.996 86.4208 169.33 87.345 169.33 88.5887V94.0655H167.786ZM164.835 94.1682C164.168 94.1682 163.58 94.0541 163.071 93.8259C162.573 93.5977 162.189 93.2839 161.917 92.8846C161.646 92.4738 161.51 92.0117 161.51 91.4983C161.51 91.0076 161.623 90.5626 161.849 90.1633C162.087 89.7639 162.466 89.4445 162.986 89.2048C163.517 88.9652 164.23 88.8454 165.123 88.8454H167.973V90.0264H165.191C164.377 90.0264 163.828 90.1633 163.546 90.4371C163.263 90.711 163.122 91.0419 163.122 91.4298C163.122 91.8748 163.297 92.2342 163.647 92.5081C163.998 92.7705 164.484 92.9017 165.106 92.9017C165.717 92.9017 166.248 92.7648 166.701 92.4909C167.164 92.2171 167.498 91.8178 167.702 91.2929L168.024 92.4225C167.809 92.9588 167.43 93.3866 166.887 93.7061C166.345 94.0142 165.66 94.1682 164.835 94.1682Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M177.029 94.1682C176.283 94.1682 175.598 93.9971 174.976 93.6548C174.366 93.3011 173.874 92.7819 173.501 92.0973C173.139 91.4127 172.958 90.5569 172.958 89.53C172.958 88.5031 173.133 87.6474 173.484 86.9628C173.846 86.2782 174.332 85.7647 174.943 85.4224C175.565 85.0801 176.26 84.909 177.029 84.909C177.911 84.909 178.691 85.1029 179.37 85.4909C180.048 85.8788 180.586 86.4208 180.981 87.1168C181.377 87.8014 181.575 88.6058 181.575 89.53C181.575 90.4542 181.377 91.2644 180.981 91.9604C180.586 92.6564 180.048 93.1984 179.37 93.5863C178.691 93.9743 177.911 94.1682 177.029 94.1682ZM172.262 97.3859V84.9945H173.823V87.442L173.721 89.5471L173.891 91.6523V97.3859H172.262ZM176.893 92.7306C177.47 92.7306 177.985 92.5993 178.437 92.3369C178.901 92.0745 179.262 91.7036 179.523 91.2244C179.794 90.7338 179.93 90.169 179.93 89.53C179.93 88.8797 179.794 88.3206 179.523 87.8528C179.262 87.3735 178.901 87.0027 178.437 86.7403C177.985 86.4778 177.47 86.3466 176.893 86.3466C176.328 86.3466 175.813 86.4778 175.35 86.7403C174.897 87.0027 174.535 87.3735 174.264 87.8528C174.004 88.3206 173.874 88.8797 173.874 89.53C173.874 90.169 174.004 90.7338 174.264 91.2244C174.535 91.7036 174.897 92.0745 175.35 92.3369C175.813 92.5993 176.328 92.7306 176.893 92.7306Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M190.455 94.0655L186.977 89.6498L188.317 88.8283L192.372 94.0655H190.455ZM183.941 94.0655V84.9945H185.569V94.0655H183.941ZM185.077 90.2318V88.8283H188.046V90.2318H185.077ZM188.453 89.7183L186.943 89.5129L190.387 84.9945H192.134L188.453 89.7183Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M200.28 92.799L197.837 89.53L200.28 86.2439H201.773L199.381 89.53L201.773 92.799H200.28ZM203.537 92.799L201.094 89.53L203.537 86.2439H205.029L202.638 89.53L205.029 92.799H203.537Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M214.361 94.0655V90.1633L214.802 90.5741H211.087C210.126 90.5741 209.294 90.4086 208.593 90.0777C207.903 89.7468 207.372 89.2733 206.999 88.6572C206.637 88.0296 206.456 87.2765 206.456 86.398C206.456 85.4852 206.654 84.7093 207.05 84.0703C207.445 83.4199 208.005 82.9293 208.729 82.5984C209.453 82.2561 210.295 82.085 211.256 82.085H216.023V94.0655H214.361ZM206.456 94.0655L209.391 89.821H211.121L208.254 94.0655H206.456ZM214.361 89.6156V83.0776L214.802 83.574H211.324C210.307 83.574 209.526 83.8136 208.983 84.2928C208.441 84.7606 208.169 85.4566 208.169 86.3809C208.169 87.2594 208.424 87.9383 208.932 88.4175C209.453 88.8968 210.216 89.1364 211.222 89.1364H214.802L214.361 89.6156Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M225.971 94.0655L222.493 89.6498L223.833 88.8283L227.888 94.0655H225.971ZM219.457 94.0655V84.9945H221.085V94.0655H219.457ZM220.594 90.2318V88.8283H223.562V90.2318H220.594ZM223.969 89.7183L222.459 89.5129L225.903 84.9945H227.65L223.969 89.7183Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M229.54 97.4886C229.11 97.4886 228.691 97.4144 228.284 97.2661C227.877 97.1291 227.527 96.9238 227.233 96.6499L227.928 95.4176C228.154 95.6344 228.403 95.7999 228.674 95.914C228.946 96.0281 229.234 96.0851 229.54 96.0851C229.935 96.0851 230.263 95.9824 230.523 95.777C230.783 95.5717 231.027 95.2065 231.253 94.6817L231.813 93.4323L231.982 93.2269L235.51 84.9945H237.105L232.746 94.9726C232.485 95.6116 232.191 96.1136 231.863 96.4788C231.547 96.8439 231.196 97.1006 230.812 97.2489C230.427 97.4087 230.003 97.4886 229.54 97.4886ZM231.677 94.3565L227.572 84.9945H229.268L232.762 93.0729L231.677 94.3565Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M240.553 94.0655V86.0043L240.96 86.4322H237.263V84.9945H245.473V86.4322H241.792L242.182 86.0043V94.0655H240.553Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M247.138 94.0655V84.9945H248.766V91.601L254.279 84.9945H255.755V94.0655H254.126V87.4591L248.63 94.0655H247.138Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M264.666 94.0655V90.8821L264.921 91.1902H262.054C260.855 91.1902 259.917 90.9335 259.238 90.42C258.571 89.9066 258.237 89.1592 258.237 88.1779C258.237 87.1282 258.593 86.3352 259.306 85.7989C260.03 85.2627 260.991 84.9945 262.19 84.9945H266.125V94.0655H264.666ZM258.152 94.0655L260.595 90.5912H262.274L259.9 94.0655H258.152ZM264.666 90.3687V85.9701L264.921 86.4322H262.24C261.494 86.4322 260.917 86.5748 260.51 86.8601C260.103 87.1339 259.9 87.5903 259.9 88.2293C259.9 89.4159 260.657 90.0093 262.173 90.0093H264.921L264.666 90.3687Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M269.794 92.799H268.301L270.693 89.53L268.301 86.2439H269.794L272.237 89.53L269.794 92.799ZM273.051 92.799H271.558L273.95 89.53L271.558 86.2439H273.051L275.494 89.53L273.051 92.799Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_236_217",
    x1: 40.4051,
    y1: 67.079,
    x2: 57.109,
    y2: 79.8424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1DAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008BD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_236_217",
    x1: 32.2433,
    y1: 75.2848,
    x2: 47.7964,
    y2: 87.1689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1DAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008BD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_236_217",
    x1: 32.0379,
    y1: 89.092,
    x2: 50.0912,
    y2: 102.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1DAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008BD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_236_217",
    x1: 41.2371,
    y1: 99.5131,
    x2: 55.8588,
    y2: 110.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1DAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008BD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_236_217",
    x1: 43.9909,
    y1: 111.816,
    x2: 55.8674,
    y2: 120.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1DAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008BD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_236_217",
    x1: 40.3507,
    y1: 54.887,
    x2: 58.2051,
    y2: 68.5295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1DAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008BD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_236_217",
    x1: 23.7466,
    y1: 90.8467,
    x2: 36.1262,
    y2: 100.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1DAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008BD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_236_217",
    x1: 22.0821,
    y1: 77.5877,
    x2: 36.8989,
    y2: 88.9093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1DAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008BD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_236_217",
    x1: 46.5171,
    y1: 60.1635,
    x2: 62.1832,
    y2: 72.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1DAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008BD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_236_217",
    x1: 46.9754,
    y1: 105.2,
    x2: 61.4968,
    y2: 116.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1DAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008BD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_236_217",
    x1: 32.609,
    y1: 99.4619,
    x2: 47.9736,
    y2: 111.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1DAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008BD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_236_217",
    x1: 35.8964,
    y1: 105.507,
    x2: 48.6453,
    y2: 115.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1DAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008BD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_236_217",
    x1: 32.1247,
    y1: 67.3264,
    x2: 47.1055,
    y2: 78.7732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1DAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008BD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_236_217",
    x1: 33.7039,
    y1: 60.182,
    x2: 51.0965,
    y2: 73.4717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1DAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008BD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_236_217",
    x1: 33.2347,
    y1: 72.7623,
    x2: 72.0513,
    y2: 102.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1DAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008BD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_236_217",
    x1: 25.7334,
    y1: 95.7283,
    x2: 43.4044,
    y2: 109.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1DAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008BD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_236_217",
    x1: 26.0476,
    y1: 81.8945,
    x2: 44.1853,
    y2: 95.7536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1DAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008BD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_236_217",
    x1: 26.2877,
    y1: 68.2815,
    x2: 43.8453,
    y2: 81.6973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1DAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008BD2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSponsor6);
export default __webpack_public_path__ + "static/media/sponsor6.7fe60e712c86a2a7726ca09405211c70.svg";
export { ForwardRef as ReactComponent };